import type { ComponentProps } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import config from 'constants/config'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuTripPlannerListItem(props: InheritedListItemProps) {
  if (!config.ENABLE_TRIP_PLANNER) return null

  return <AccountMenuTripPlannerListItemInner {...props} />
}

function AccountMenuTripPlannerListItemInner(props: InheritedListItemProps) {
  const intl = useIntl()

  const wishlistsText = intl.formatMessage({
    id: 'xrDH7TOWPQWTX6sgu1rp',
    defaultMessage: 'Wishlist',
  })

  return (
    <NavBarListItem
      {...props}
      startIcon={<NavBarListItemIcon Icon={LineHeartIcon} colour="primary" />}
      title={wishlistsText}
      to="/wishlists"
    />
  )
}

export default AccountMenuTripPlannerListItem
